import { createSelector } from 'reselect';

import getShop from '@core/reducers/shop/selectors/getShop';
import getIsNewUser from '@core/reducers/user/selectors/getIsNewUser';
import { getHasOnlinePaymentMethod } from '@payments/selectors';
import { hasSkuLimit } from '@utils/shop';

import getOnlinePaymentTooltipClosed from './getOnlinePaymentTooltipClosed';

const getShowOnlinePaymentTooltip = createSelector(
  getShop,
  getHasOnlinePaymentMethod,
  getOnlinePaymentTooltipClosed,
  getIsNewUser,
  (shop, hasOnlinePaymentMethod, tooltipClosed, isNewUser) =>
    !hasSkuLimit(shop) && hasOnlinePaymentMethod && !tooltipClosed && isNewUser,
);

export default getShowOnlinePaymentTooltip;
